import axios from '../config/axios';

const API_BASE = '/commissions';

export const commissionService = {
  getAllCommissions: (page = 1, perPage = 20, filters = {}) => {
    const params = { page, per_page: perPage, ...filters };
    return axios.get(API_BASE, { params });
  },

  getCommission: (commissionId) => {
    return axios.get(`${API_BASE}/${commissionId}`);
  },

  createCommission: (data) => {
    return axios.post(API_BASE, data);
  },

  updateCommission: (commissionId, data) => {
    return axios.put(`${API_BASE}/${commissionId}`, data);
  },

  deleteCommission: (commissionId) => {
    return axios.delete(`${API_BASE}/${commissionId}`);
  },

  calculatePreview: (mlSheetId, officeCommissionPercent = 30) => {
    return axios.get(`${API_BASE}/calculate-preview`, {
      params: { 
        ml_sheet_id: mlSheetId,
        office_commission_percent: officeCommissionPercent
      }
    });
  },

  getAccountants: () => {
    return axios.get(`${API_BASE}/accountants`);
  },

  getHubsByMlSheet: (mlSheetId) => {
    return axios.get(`${API_BASE}/hubs-by-ml-sheet`, {
      params: { ml_sheet_id: mlSheetId }
    });
  },

  getHubCommissionRecords: (hubId, hubType) => {
    return axios.get(`${API_BASE}/hub-records`, {
      params: { hub_id: hubId, hub_type: hubType }
    });
  },

  paySenderHub: (commissionId, data) => {
    return axios.put(`${API_BASE}/${commissionId}/pay-sender-hub`, data);
  },

  payReceiverHub: (commissionId, data) => {
    return axios.put(`${API_BASE}/${commissionId}/pay-receiver-hub`, data);
  },

  getCompanyProfiles: () => {
    return axios.get('/company-profiles', { params: { all: true } });
  },
  
  getVehicleOwners: () => {
    return axios.get('/vehicle-owners', { params: { all: true } });
  },

  downloadCommissionReport: (params = {}) => {
    return axios.get(`${API_BASE}/download-report`, {
      params,
      responseType: 'blob'
    });
  },
};

export default commissionService;
